import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {FolderTagModel} from "../../models/folder-tag.model";
import {SpotifyTagsService} from "../../services/spotify-tags-service";
import {ActivatedRoute, Router} from "@angular/router";
import {switchMap} from "rxjs/operators";
import {TagModel} from "../../models/tag.model";
import {FormControl} from "@angular/forms";
import {ExpandedFoldersService} from "../../services/expanded-folders-service";
import {Subscription} from "rxjs";
import {LoadingService} from "../../services/loading.service";

@Component({
  selector: 'app-folder-tags',
  templateUrl: './folder-tags.component.html',
  styleUrls: ['./folder-tags.component.css']
})
export class FolderTagsComponent implements OnInit, OnDestroy {

  folderTag: FolderTagModel;
  showEditMenu = false;
  tagFilter = new FormControl('');
  tagsFiltered: TagModel[];
  folderEditedSubscription: Subscription;
  loading$ = this.loadingService.loading$;

  constructor(private spotifyTagService: SpotifyTagsService,
              private expandedFoldersService: ExpandedFoldersService,
              private route: ActivatedRoute,
              private router: Router,
              private loadingService: LoadingService) {}

  ngOnInit() {
    this.route.paramMap.pipe(
      switchMap(params => {
        return this.spotifyTagService.getFolderTags(Number(params.get('folderId')))
      })
    ).subscribe(response => {
      this.folderTag = response;
      this.tagsFiltered = this.folderTag.tags;
      this.tagFilter.valueChanges.subscribe(value =>{
        if (!value) {
          this.tagsFiltered = this.folderTag.tags;
        } else {
          this.tagsFiltered = this.folderTag.tags.filter(tag => tag.tag.toLowerCase().includes(value.toLowerCase()));
        }
      })
    });
    this.folderEditedSubscription = this.spotifyTagService.folderEdited$.subscribe(folderName => this.folderTag.folder = folderName);
  }

  ngOnDestroy(): void {
    this.folderEditedSubscription.unsubscribe();
  }

  underline() {
    (<Element>event.srcElement.lastChild).classList.add("underline");
  }

  removeUnderline() {
    (<Element>event.srcElement.lastChild).classList.remove("underline");
  }

  navigateToTag(folderTag: FolderTagModel, tag: TagModel) {
    this.expandedFoldersService.addFolderToExpand(folderTag.folderId);
    this.router.navigateByUrl(folderTag.tagType == 'ARTIST' ? `/artists/${tag.tagId}` : `/albums/${tag.tagId}`)
  }

  toggeEditMenu(event: Event) {
    event.stopPropagation();
    this.showEditMenu = !this.showEditMenu;
  }

  @HostListener('click')
  hideEditMenuAgain() {
    this.showEditMenu = false;
  }

  @HostListener('document:click')
  hideEditMenu() {
    this.showEditMenu = false;
  }

  editFolder() {
    this.spotifyTagService.passEditFolder(this.folderTag);
    this.showEditMenu = false;
  }

  deleteFolder() {
    this.spotifyTagService.passDeleteFolder(this.folderTag.folderId);
    this.showEditMenu = false;
  }
}
